import { useEffect, useState } from 'react';
import { useUpdateEffect } from './hook-utils';

export const usePaginateHandler = (
  onChangePage?: (page: number, rowsPerPage: number) => void,
  totalPages?: number,
  defaultPage?: number,
  defaultRowsPerPage?: number,
  onRefresh?: () => void
) => {
  const [page, setPage] = useState<number>(defaultPage ?? 0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(defaultRowsPerPage ?? 20);
  const [shouldReloadData, setShouldReloadData] = useState<boolean>(false);

  const handleChangePage = (event: any, newPage: number) => {
    setPage(newPage);
  };

  useEffect(() => {
    if (totalPages !== undefined && page + 1 > totalPages) {
      setPage(0);
    }
  }, [totalPages, page]);

  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
  };

  useUpdateEffect(() => {
    if (onChangePage) {
      onChangePage(page + 1, rowsPerPage);
      setShouldReloadData(true);
    }
  }, [page, rowsPerPage]);

  useUpdateEffect(() => {
    if (shouldReloadData) {
      onRefresh && onRefresh();
      setShouldReloadData(false);
    }
  }, [shouldReloadData]);

  return {
    page,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
  };
};
